import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeListController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeListController.php
* @route '/api/payment-mode'
*/
const GetPaymentModeListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentModeListController.url(options),
    method: 'get',
})

GetPaymentModeListController.definition = {
    methods: ["get","head"],
    url: '/api/payment-mode',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeListController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeListController.php
* @route '/api/payment-mode'
*/
GetPaymentModeListController.url = (options?: RouteQueryOptions) => {
    return GetPaymentModeListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeListController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeListController.php
* @route '/api/payment-mode'
*/
GetPaymentModeListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentModeListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeListController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeListController.php
* @route '/api/payment-mode'
*/
GetPaymentModeListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPaymentModeListController.url(options),
    method: 'head',
})

export default GetPaymentModeListController